import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { CHECKOUT_URL, PRICE, PRICE_FULL } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-b border-line bg-canvas" data-id="element-51" data-mp="c4o5s47ajoxs">
      <div className="mx-auto max-w-2xl px-4 py-9 text-center sm:px-6" data-id="element-52" data-mp="87a20s2dq9d6">
        <p className="font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-danger" data-id="element-53" data-mp="m3nf7ozvrolu">
          Una última oportunidad
        </p>
        <h2 id="cierre" className="mt-2 font-display text-lg font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-54" data-mp="vurukptgxbh7">
          La Electrónica puede convertirse en mucho más que información guardada
          en tu computadora
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-ink-muted" data-id="element-55" data-mp="14vpr6n1kugpr">
          Dejá de pasar horas saltando entre tutoriales, PDFs y circuitos
          sueltos. Empezá a aprender con un sistema organizado y llevá tus
          conocimientos a la práctica.
        </p>

        <Reveal className="mt-4 rounded-2xl border-2 border-accent bg-surface p-5" data-id="element-56" data-mp="2h4j3b3iuc2su">
          <p className="font-display text-sm font-extrabold uppercase text-ink" data-id="element-57" data-mp="2m1swmu9coyly">
            Mega Pack Electrónica para Emprender + 5 Bonos
          </p>
          <p className="mt-2 text-xs text-ink-subtle line-through" data-id="element-58" data-mp="2qzksfzd494vf">
            {PRICE_FULL} ARS
          </p>
          <p className="font-display text-3xl font-black text-accent sm:text-4xl" data-id="element-59" data-mp="302c4a09wm2nl">
            Solo {PRICE}
            <span className="ml-1.5 text-base font-bold text-ink-muted" data-id="element-60" data-mp="34sshbj9tbm9f">
              ARS
            </span>
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-4" data-id="element-61" data-mp="39rdj3n4pqdzz">
            Sí, quiero mi Mega Pack
          </CtaButton>

          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[0.7rem] text-ink-muted" data-id="element-62" data-mp="3epf268252dbg">
            <span className="flex items-center gap-1.5" data-id="element-63" data-mp="1jod0qlp67e08">
              <ZapIcon size={12} className="text-accent" data-id="element-64" data-mp="1jov6c8xq34kt" />
              Acceso inmediato
            </span>
            <span className="text-ink-subtle" data-id="element-65" data-mp="1er3bb61s72ce">•</span>
            <span className="flex items-center gap-1.5" data-id="element-66" data-mp="1sgx05odadmm4">
              <LockIcon size={12} className="text-ink-subtle" data-id="element-67" data-mp="1sihw9if91dm3" />
              Pago seguro — Mercado Pago
            </span>
            <span className="text-ink-subtle" data-id="element-68" data-mp="22ekyeoa3pc91">•</span>
            <span className="flex items-center gap-1.5" data-id="element-69" data-mp="22d01is0bdh80">
              <ShieldCheckIcon size={12} className="text-success" data-id="element-70" data-mp="1xg9q4hzgf9sx" />
              Garantía 7 días — Cero riesgo
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}